import { Component, DestroyRef, OnInit, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TitleService } from "@app/services/title.service";
import { OwlOptions } from "ngx-owl-carousel-o";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
    selector: "app-case-studies-three-columns-page",
    templateUrl: "./case-studies-three-columns-page.component.html",
    styleUrls: ["./case-studies-three-columns-page.component.scss"],
})
export class CaseStudiesThreeColumnsPageComponent implements OnInit {
    private destroyRef = inject(DestroyRef);

    customOptions: OwlOptions = {
        loop: false,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        dots: false,
        margin: 6,
        items: 5,
        lazyLoad: true,
        navSpeed: 600,
        navText: ["Prev", "Next"],
        responsive: {
            0: {
                items: 1,
            },
            400: {
                items: 3,
            },
            760: {
                items: 5,
            },
            1000: {
                items: 5,
            },
        },
        nav: true,
    };
    pageData = "";
    loading = true;
    pageTitleArea: pageTitle[] = [
        {
            title: "Success Stories",
        },
    ];
    singleProjectsBox: singleProjectsContent[] = [
        {
            icon: "bx bx-plus",
            img: "assets/img/projects/img1.jpg",
            imgClass: "",
            title: "Global Well List",
            subTitle:
                "Created a global list of wells with well operating status, company code, ownership, and other standard well header metadata that is automatically generated and maintained that is easily curated and validated to make the well list authoritative/trusted.",
            link: "success-stories-details",
        },
    ];

    constructor(
        private route: ActivatedRoute,
        private titleService: TitleService,
    ) {}

    liststories: any = [];

    ngOnInit(): void {
        // console.log(userInfo)
        this.route.data
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((data) => {
                switch (data.kind) {
                    case "data-foundation": {
                        this.pageData = "data-foundation";
                        this.pageTitleArea = [
                            {
                                title: "Data Foundation",
                            },
                        ];
                        this.singleProjectsBox = [
                            {
                                icon: "bx bx-plus",
                                img: "assets/img/history/img2.jpg",
                                imgClass: "",
                                title: "Data Governance",
                                subTitle:
                                    "Data Governance is the exercise of authority and control (planning, monitoring, and enforcement) over the management of data assets.",
                                link: "data-foundation-governance",
                            },
                            {
                                icon: "bx bx-plus",
                                img: "assets/img/history/img1.jpg",
                                imgClass: "",
                                title: "Data Architecture & Modeling",
                                subTitle:
                                    "Data architecture translates business needs into data and system requirements and manages data as it flows through the enterprise.",
                                link: "data-foundation-architecture",
                            },
                            {
                                icon: "bx bx-plus",
                                img: "assets/img/projects/img3.jpg",
                                imgClass: "faqs",
                                title: "FAQs",
                                subTitle:
                                    "Commonly asked questions about the Upstream Data Foundation, Governance, Architecture, and Modeling.",
                                link: "data-foundation-faqs",
                            },
                            {
                                icon: "bx bx-plus",
                                img: "assets/img/projects/img8.jpg",
                                imgClass: "",
                                title: "Upstream Data <br/> Foundation ",
                                subTitle:
                                    "The Upstream Data Foundation (UDF) is an aspirational architectural conceptual target for the unified, governed view of ExxonMobil's Upstream data as well as an organization in Upstream Digital responsible for stewarding the foundation's ongoing architectural and governance efforts.",
                                link: "https://wiki.na.xom.com/index.php/Upstream_Data_Foundation",
                            },
                            {
                                icon: "bx bx-plus",
                                img: "assets/img/projects/img5.jpg",
                                imgClass: "",
                                title: "Upstream Data <br/> Foundations Operations",
                                subTitle:
                                    "The Upstream Data Foundation Operations (UDFO) provides timely access to reliable data, delivers quality data engineering services, and offers data support to UDF users to enable valuable insights. In essence, the UDF provides data and makes it accessible and useful.",
                                link: "https://wiki.na.xom.com/index.php/Upstream_Data_Foundation_Operations",
                            },
                            {
                                icon: "bx bx-plus",
                                img: "assets/img/projects/img1.jpg",
                                imgClass: "",
                                title: "Upstream Data <br/> Governance Services",
                                subTitle:
                                    "The Upstream Data Foundation Service (UDFS) is a team organizationally positioned within EMTEC/Upstream Technology Portfolio/Digital & Data, comprised of the Upstream Data Governance Program (UDGP) and Upstream Data Foundation Operations (UDFO).",
                                link: "https://wiki.na.xom.com/index.php/Upstream_Data_Foundation_Service",
                            },
                        ];
                        this.titleService.setTitle("Data Foundation");
                        break;
                    }
                }
            });
    }
}
class pageTitle {
    title: string;
}
class singleProjectsContent {
    icon: string;
    img: string;
    imgClass: string;
    title: string;
    subTitle: string;
    link: string;
}
